import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark_partial_s",
  "use": "checkmark_partial_s-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"checkmark_partial_s\"><path d=\"M1 7h14v3H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol